import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormFrameComponent } from './components/form-frame/form-frame.component';
import { Step1Component } from './components/step1/step1.component';
import { Step2Component } from './components/step2/step2.component';
import { Step3Component } from './components/step3/step3.component';
import { Step4Component } from './components/step4/step4.component';
import { Globals } from './models/Globals';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GateKeeperComponent } from './components/gate-keeper/gate-keeper.component';
import { PhoneMaskDirective } from './shared/PhoneMaskDirective';
import { MmYyMaskDirective } from './shared/MmYyMaskDirective';
import { SafeHtmlPipe } from './shared/SafeHtml';
import { DigitMaskDirective } from './shared/DigitMaskDirective';

@NgModule({
  declarations: [
    AppComponent,
    FormFrameComponent,
    Step1Component,
    Step2Component,
    Step3Component,
    Step4Component,
    GateKeeperComponent,
    PhoneMaskDirective,
    MmYyMaskDirective,
    SafeHtmlPipe,
    DigitMaskDirective
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    AppRoutingModule,
    NgbModule
  ],
  providers: [Globals],
  bootstrap: [AppComponent]
})
export class AppModule { }
